import Spinners from "components/Shared/Spinners"
import { patch, post } from "helpers/api_helper"
import { NEW_USER_RESET_PASSWORD, VALIDATE_UUID } from "helpers/url_helper"
import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { Link, useNavigate, useParams } from "react-router-dom"
import { Card, CardBody, Col, Label, Row } from "reactstrap"
import { showAlert } from "store/reducers/alertReducer"
import logo from "../../assets/images/logo.svg"
import { Formik, Form, Field, ErrorMessage } from "formik"
import {
  resetPasswordSchemaForUser,
  userResetPasswordSchema,
} from "components/Common/validation"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"

const ResetPassword = () => {
  const { t } = useTranslation()

  document.title = t("Reset Password | Sign Burger")

  const [loading, setLoading] = useState(true)
  const [uuidValidateInfo, setUuidValidateInfo] = useState({})

  const { uuid } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  useEffect(() => {
    uuid && validateUuid()
  }, [])

  const validateUuid = async () => {
    const payload = {
      uuid,
    }
    const result = await post(VALIDATE_UUID, payload)
    if (result) {
      setLoading(false)
      if (result?.statusCode === 200 && result?.status) {
        setUuidValidateInfo(result.data)
      } else {
        dispatch(showAlert({ text: result.msg, type: "error" }))
        navigate("/login")
      }
    }
  }

  const handleNewPassword = async (values, { resetForm }) => {
    const { newPassword, confirmPassword } = values
    const payload = {
      id: uuidValidateInfo._id,
      newPassword,
      confirmPassword,
      uuid,
    }
    const result = await patch(NEW_USER_RESET_PASSWORD, payload)
    if (result) {
      if (result?.statusCode === 200 && result?.status) {
        dispatch(showAlert({ text: result.msg, type: "success" }))
        navigate("/login")
      } else {
        dispatch(showAlert({ text: result.msg, type: "error" }))
      }
    }
  }

  if (loading) return <Spinners />
  return (
    <div className="account-pages">
      <div className="login_form">
        <Card className="overflow-hidden">
          <div className="bg-primary-subtle">
            <Row>
              <Col xs={7}>
                <div className="text-primary p-4">
                  <h5 className="text-primary">
                    {t("Welcome")}{" "}
                    {uuidValidateInfo.firstName +
                      " " +
                      uuidValidateInfo.lastName}
                  </h5>
                  <p>{t("Please reset your password")}</p>
                </div>
              </Col>
              <Col className="col-5 align-self-end">
                {/* <img src={logo} alt="" className="img-fluid" /> */}
              </Col>
            </Row>
          </div>
          <CardBody className="pt-4">
            <div className="p-2">
              <Formik
                initialValues={{ newPassword: "", confirmPassword: "" }}
                validationSchema={resetPasswordSchemaForUser}
                onSubmit={handleNewPassword}
              >
                {({ values, errors, touched, isSubmitting }) => (
                  <Form className="form-horizontal">
                    <div className="mb-3">
                      <Label className="form-label">
                        {t("New Password")}
                      </Label>
                      <div className="position-relative">
                        <Field
                          name="newPassword"
                          className={`form-control has_common_eye ${
                            touched.newPassword &&
                            errors.newPassword &&
                            "is-invalid"
                          }`}
                          placeholder={t("New Password")}
                          type={showPassword ? "text" : "password"}
                        />
                        <i
                          onClick={() => setShowPassword(!showPassword)}
                          className={`bx bx-${
                            showPassword ? "show-alt" : "hide"
                          } common_eye`}
                        ></i>
                      </div>
                      <TextError name="newPassword" />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        {t("Confirm Password")}
                      </Label>
                      <div className="position-relative">
                        <Field
                          name="confirmPassword"
                          className={`form-control has_common_eye ${
                            touched.confirmPassword &&
                            errors.confirmPassword &&
                            "is-invalid"
                          }`}
                          placeholder={t("Confirm Password")}
                          type={showConfirmPassword ? "text" : "password"}
                        />
                        <i
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                          className={`bx bx-${
                            showConfirmPassword ? "show-alt" : "hide"
                          } common_eye`}
                        ></i>
                      </div>
                      <TextError name="confirmPassword" />
                    </div>
                    <Row className="">
                      <Col className="text-end">
                        <button
                          className="btn btn-primary w-md "
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {t("Save")}
                        </button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </div>
          </CardBody>
        </Card>
        <div className="text-center auth-page-footer">
          <p>
            {t("Go back to")}{" "}
            <Link to="/login" className="font-weight-medium text-black">
              {t("Login")}
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword
